import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../components/commentBox";
import PageHeader from "../../../components/pageHeader";
import TaskCheckedList from "../../../components/taskCheckedList";

import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

function FAQLinks({ itemId, listId, alreadyCheckedItems }) {
  const isItemChecked = alreadyCheckedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="FAQ Links" />
          </Col>
          <Col span={24}>
            <h3>
              Below are links to some items in our process and procedure manual
              that may be helpful with the move out process
            </h3>
          </Col>
          <Col span={24}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <span className="onclick-text">collections</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">normal wear and tear</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">keys</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">move out process</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">non renewal notices</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">notice to remedy </span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">property inspections</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">rental history</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">SD refund</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Tenant completed repairs</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">tenant rent refunds</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Utilities</span>
              </Col>
              <Col span={24}>
                <span className="onclick-text">Vacant property process</span>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button
                  type="primary"
                  onClick={handleComplete}
                  disabled={isDisabled}
                >
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default FAQLinks;
